import { fabric } from "fabric";
import FontFaceObserver from "fontfaceobserver";
import { notification } from "antd";
// Top right notification popup
const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: message,
    description: "",
  });
};

export const handleFontChange = (e, canvas) => {
  var myfont = new FontFaceObserver(e);
  myfont
    .load()
    .then(function() {
      const selectedText = canvas.getActiveObject();
      // when font is loaded, use it.
      if (selectedText) {
        if (selectedText.text) {
          canvas.getActiveObject().fontFamily = e;
          canvas.renderAll();
        } else {
          openNotificationWithIcon("error", "Please Select a text");
        }
      } else {
        openNotificationWithIcon("error", "Please select a text");
      }
    })
    .catch(function(e) {
      openNotificationWithIcon("error", "Font loading failed" + e);
    });
  return e;
};

export const handleFontSizeChange = (e, canvas) => {
  var obj = canvas.getActiveObject();

  if (!obj) {
    return;
  }
  if (obj.type !== "i-text") {
    openNotificationWithIcon("error", "Please Select a text");
    return;
  }

  obj.fontSize = e;
  canvas.renderAll();
};

export const handleFontBgColor = (e, canvas) => {
  var obj = canvas.getActiveObject();

  if (!obj) {
    return;
  }

  obj.set("backgroundColor", e.hex);
  canvas.renderAll();
};
export const handleFontColor = (e, canvas) => {
  var obj = canvas.getActiveObject();

  if (!obj) {
    return;
  }
  if (obj._objects) {
    for (var i = 0; i < obj._objects.length; i++) {
      obj._objects[i].fill = e.hex;
    }
    obj.set({
      scaleX: (obj.scaleX * 99.99999) / 100,
      scaleY: (obj.scaleY * 99.99999) / 100,
    });
  } else {
    obj.set({ fill: e.hex });
  }
  canvas.renderAll();
};

export const handleFontStyleChange = (
  currentFontStyle,
  setCurrentFontStyle,
  canvas
) => {
  var obj = canvas.getActiveObject();

  if (!obj) {
    return;
  }
  if (obj.type !== "i-text") {
    openNotificationWithIcon("error", "Please Select a text");
    return;
  }
  setCurrentFontStyle(
    currentFontStyle < 2 ? (currentFontStyle += 1) : (currentFontStyle = 0)
  );

  switch (currentFontStyle) {
    case 0:
      obj.fontWeight = "normal";
      obj.fontStyle = "";
      break;
    case 1:
      obj.fontWeight = "bold";
      obj.fontStyle = "";
      break;
    case 2:
      obj.fontStyle = "italic";
      break;
    default:
      break;
  }
  canvas.renderAll();
};

export const sliddervaluechange = (e, setInputValue, canvas) => {
  var obj = canvas.getActiveObject();
  if (obj) {
    if (obj.fontFamily) {
      obj.lineHeight = e;
      setInputValue(e);
      canvas.renderAll();
    } else {
      openNotificationWithIcon("error", "Please select a text");
    }
  } else {
    openNotificationWithIcon("error", "Please Select a text");
  }
};

export const sliddervaluechange2 = (e, setInputValue2, canvas) => {
  var obj = canvas.getActiveObject();
  if (obj) {
    if (obj.fontFamily) {
      setInputValue2(e);
      obj.set({ charSpacing: e * 1000 });
      // obj.charSpacing = e
      // charSpacing: 20
      canvas.renderAll();
    } else {
      openNotificationWithIcon("error", "Please select a text");
    }
  } else {
    openNotificationWithIcon("error", "Please select a text");
  }
};

export const addText = (canvas) => {
  let text = new fabric.IText("Add Text!");
  text.textAlign = "left";
  canvas.add(text);
  canvas.renderAll();
};
export const alignLeft = (canvas) => {
  var obj = canvas.getActiveObject();
  if (obj) {
    if (obj.fontFamily) {
      obj.textAlign = "left";
      canvas.renderAll();
    } else {
      openNotificationWithIcon("error", "Please select a text");
    }
  } else {
    openNotificationWithIcon("error", "Please select a text");
  }
};
export const alignRight = (canvas) => {
  var obj = canvas.getActiveObject();
  if (obj) {
    if (obj.fontFamily) {
      obj.textAlign = "right";
      canvas.renderAll();
    } else {
      openNotificationWithIcon("error", "Please select a text");
    }
  } else {
    openNotificationWithIcon("error", "Please select a text");
  }
};
export const alignCenter = (canvas) => {
  var obj = canvas.getActiveObject();
  if (obj) {
    if (obj.fontFamily) {
      obj.textAlign = "center";
      canvas.renderAll();
    } else {
      openNotificationWithIcon("error", "Please select a text");
    }
  } else {
    openNotificationWithIcon("error", "Please select a text");
  }
};

export const addImage = async (e, canvas) => {
  const image = e.target.files[e.target.files.length - 1];
  var reader = new FileReader();
  reader.onload = function(readerEvt) {
    var binaryString = readerEvt.target.result;
    fabric.Image.fromURL(
      "data:image/png;base64," + window.btoa(binaryString),
      function(myImg) {
        var img1 = myImg.set({ left: 20, top: 20 });
        canvas.add(img1);
        canvas.renderAll();
      }
    );
  };
  reader.readAsBinaryString(image);
  e.target.value = null;
};
const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  // For Fabric Image return a base64 data string fromat...
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};
export const addImageFromPexels = async (e, canvas, setImgLoader) => {
  var base64 = await getBase64FromUrl(e);
  fabric.Image.fromURL(base64, function(myImg) {
    const scale = Math.min(
      canvas.height / myImg.height,
      canvas.width / myImg.width
    );
    var img1 = myImg.set({
      scaleX: (scale * 90) / 100,
      scaleY: (scale * 90) / 100,
    });
    canvas.add(img1).centerObject(img1).renderAll()
    setImgLoader(false);
  });
};
export const pageBgImage = (e, canvas) => {
  const image = e.target.files[e.target.files.length - 1];
  var reader = new FileReader();
  reader.onload = function(readerEvt) {
    var binaryString = readerEvt.target.result;
    fabric.Image.fromURL(
      "data:image/png;base64," + window.btoa(binaryString),
      function(myImg) {
        var canvasAspect = canvas.width / canvas.height;
        var imgAspect = myImg.width / myImg.height;
        var left, top, scaleFactor;

        if (canvasAspect >= imgAspect) {
          scaleFactor = canvas.width / myImg.width;
          left = 0;
          top = -(myImg.height * scaleFactor - canvas.height) / 2;
        } else {
          scaleFactor = canvas.height / myImg.height;
          top = 0;
          left = -(myImg.width * scaleFactor - canvas.width) / 2;
        }

        canvas.setBackgroundImage(myImg, canvas.renderAll.bind(canvas), {
          top: top,
          left: left,
          originX: "left",
          originY: "top",
          scaleX: scaleFactor,
          scaleY: scaleFactor,
        });
        canvas.renderAll();
      }
    );
  };
  reader.readAsBinaryString(image);

  e.target.value = null;
};

export const deleteObject = (canvas) => {
  var obj = canvas.getActiveObject();
  if (obj) {
    canvas.remove(obj);
    canvas.renderAll();
  } else {
    openNotificationWithIcon("error", "Please select only one object");
  }
};
export const clearCanvas = (canvas) => {
  canvas.clear();
  canvas.setBackgroundImage(null);
  canvas.backgroundColor = "#ffffff";
  canvas.renderAll();
};

export const changePageBgColorOnChange = (canvas, color) => {
  canvas.setBackgroundImage(null);
  canvas.backgroundColor = color.hex;
  canvas.renderAll();
};
export const changePageBgColorOnChangeComplete = (canvas, color) => {
  canvas.backgroundColor = color.hex;
  canvas.renderAll();
};
export const objectBringForward = (canvas) => {
  const obj = canvas.getActiveObject();
  if (obj) {
    canvas.bringForward(obj);
    canvas.renderAll();
  } else {
    openNotificationWithIcon("error", "Please select an object");
  }
};
export const objectSendBackward = (canvas) => {
  const obj = canvas.getActiveObject();
  if (obj) {
    canvas.sendBackwards(obj);
    canvas.renderAll();
  } else {
    openNotificationWithIcon("error", "Please select an object");
  }
};
export const changeOpacity = (canvas, setOpacityValue, value) => {
  const obj = canvas.getActiveObject();
  if (obj) {
    setOpacityValue(value);
    obj.set({ opacity: value });
    canvas.renderAll();
  } else {
    openNotificationWithIcon("error", "Please select an object");
  }
};

export const addCircle = (canvas) => {
  var circle = new fabric.Circle({
    radius: 100,
    fill: "",
    stroke: "black",
    top: 100,
    left: 100,
    strokeWidth: 2,
    strokeUniform: true,
  });
  canvas.add(circle);
  canvas.renderAll();
};
export const addRectangle = (canvas) => {
  var rectangle = new fabric.Rect({
    width: 200,
    height: 100,
    top: 100,
    left: 100,
    fill: "",
    stroke: "#000000",
    strokeWidth: 3,
    strokeUniform: true,
  });
  canvas.add(rectangle);
  canvas.renderAll();
};

export const addTriangle = (canvas) => {
  var tri = new fabric.Triangle({
    top: 100,
    left: 100,
    width: 200,
    height: 200,
    fill: "",
    stroke: "#000000",
    strokeWidth: 3,
    strokeUniform: true,
  });
  canvas.add(tri);
  canvas.renderAll();
};

export const addPolygone = (canvas, shape) => {
  var path = [];
  switch (shape) {
    case "trapzoid":
      path = [
        { x: -100, y: -50 },
        { x: 100, y: -50 },
        { x: 150, y: 50 },
        { x: -150, y: 50 },
      ];
      break;
    case "hexagone":
      path = [
        { x: 850, y: 75 },
        { x: 958, y: 137.5 },
        { x: 958, y: 262.5 },
        { x: 850, y: 325 },
        { x: 742, y: 262.5 },
        { x: 742, y: 137.5 },
      ];
      break;
    case "star4":
      path = [
        { x: 0, y: 0 },
        { x: 100, y: 50 },
        { x: 200, y: 0 },
        { x: 150, y: 100 },
        { x: 200, y: 200 },
        { x: 100, y: 150 },
        { x: 0, y: 200 },
        { x: 50, y: 100 },
        { x: 0, y: 0 },
      ];
      break;
    case "star5":
      path = [
        { x: 350, y: 75 },
        { x: 380, y: 160 },
        { x: 470, y: 160 },
        { x: 400, y: 215 },
        { x: 423, y: 301 },
        { x: 350, y: 250 },
        { x: 277, y: 301 },
        { x: 303, y: 215 },
        { x: 231, y: 161 },
        { x: 321, y: 161 },
      ];
      break;
    default:
      break;
  }

  var poly = new fabric.Polygon(path, {
    top: 180,
    left: 200,
    fill: "",
    stroke: "black",
    strokeWidth: 2,
    strokeUniform: true,
    paintFirst: "stroke",
  });
  canvas.add(poly);
  canvas.renderAll();
};

export const addLine = (canvas) => {
  var line,
    isDown,
    mode = "draw";
  canvas.on("mouse:down", function(o) {
    isDown = true;
    var pointer = canvas.getPointer(o.e);
    var points = [pointer.x, pointer.y, pointer.x, pointer.y];

    if (mode === "draw") {
      line = new fabric.Line(points, {
        strokeWidth: 5,
        fill: "black",
        stroke: "black",
        originX: "center",
        originY: "center",
        strokeUniform: true,
        paintFirst: "stroke",
      });
      canvas.add(line);
    }
  });
  canvas.on("mouse:move", function(o) {
    if (!isDown) return;
    var pointer = canvas.getPointer(o.e);

    if (mode === "draw") {
      line.set({ x2: pointer.x, y2: pointer.y });
      canvas.renderAll();
    }
  });

  canvas.on("mouse:up", function(o) {
    isDown = false;
    line.setCoords();
    mode = "select";
  });
};

export const addStroke = (canvas, e) => {
  var obj = canvas.getActiveObject();

  if (!obj) {
    return;
  }
  obj.set("strokeWidth", e);
  obj.set("paintFirst", "stroke");
  obj.set("stroke", "#000000");
  obj.set("strokeUniform", true);
  canvas.renderAll();
};

export const handleStrokeColor = (e, canvas) => {
  var obj = canvas.getActiveObject();

  if (!obj) {
    return;
  }
  obj.set("paintFirst", "stroke");
  obj.set("stroke", e.hex);
  obj.set("strokeUniform", true);
  canvas.renderAll();
};

export const handleStrokeStyleChange = (e, canvas) => {
  var obj = canvas.getActiveObject();

  switch (e) {
    case "dotted":
      // obj.strokeDashArray = [10];
      break;
    case "normal":
      obj.strokeDashArray = "";
      break;
    case "none":
      obj.strokeDashArray = "";
      obj.stroke = "";
      obj.strokeWidth = "";
      //Here Can't change width of stroke
      console.log(obj);
      break;
    default:
      break;
  }
  canvas.renderAll();
};

//Shadow Section
export const xAxisChange = (e, setXAxis, canvas) => {
  var obj = canvas.getActiveObject();
  var oldOffSet;
  if (obj) {
    if (obj.shadow) {
      oldOffSet = obj.shadow;
    } else {
      oldOffSet = {};
    }
    setXAxis(e);
    var shadow = new fabric.Shadow({
      ...oldOffSet,
      offsetX: e,
    });
    obj.shadow = shadow;

    canvas.renderAll();
  } else {
    openNotificationWithIcon("error", "Please select a object");
  }
};
export const yAxisChange = (e, setYAxis, canvas) => {
  var obj = canvas.getActiveObject();
  var oldOffSet;
  if (obj) {
    if (obj.shadow) {
      oldOffSet = obj.shadow;
    } else {
      oldOffSet = {};
    }
    setYAxis(e);
    var shadow = new fabric.Shadow({
      ...oldOffSet,
      offsetY: e,
    });

    obj.shadow = shadow;

    canvas.renderAll();
  } else {
    openNotificationWithIcon("error", "Please select a object");
  }
};
export const blurChange = (e, setBlur, canvas) => {
  var obj = canvas.getActiveObject();
  var oldOffSet;
  if (obj) {
    if (obj.shadow) {
      oldOffSet = obj.shadow;
    } else {
      oldOffSet = {};
    }
    setBlur(e);
    var shadow = new fabric.Shadow({
      ...oldOffSet,
      blur: e,
    });
    obj.shadow = shadow;
    canvas.renderAll();
  } else {
    openNotificationWithIcon("error", "Please select a object");
  }
};

export const handleShadowColor = (e, canvas) => {
  var obj = canvas.getActiveObject();
  if (!obj) {
    return;
  }
  var oldOffSet = obj.shadow;
  var shadow = new fabric.Shadow({
    ...oldOffSet,
    color: e.hex,
  });
  obj.shadow = shadow;
  canvas.renderAll();
};
let color2 = "#ffffff";
let color1 = "#ffffff";
export const handleCustomGradientBoxColor = (e, canvas) => {
  var obj = canvas.getActiveObject();
  if (!obj) {
    return;
  }
  obj.set(
    "fill",
    new fabric.Gradient({
      //gradient options
      type: "linear",
      gradientUnits: "pixels", // or 'percentage'
      coords: { x1: 0, y1: 0, x2: obj.width, y2: obj.height },
      colorStops: [
        { offset: 0, color: e.hex },
        { offset: 1, color: color2 },
      ],
    })
  );
  color1 = e.hex;

  canvas.renderAll();
};
export const handleCustom2GradientBoxColor = (e, canvas) => {
  var obj = canvas.getActiveObject();
  if (!obj) {
    return;
  }
  obj.set(
    "fill",
    new fabric.Gradient({
      //gradient options
      type: "linear",
      gradientUnits: "pixels", // or 'percentage'
      coords: { x1: 0, y1: 0, x2: obj.width, y2: obj.height },
      colorStops: [
        { offset: 0, color: color1 },
        { offset: 1, color: e.hex },
      ],
    })
  );
  color2 = e.hex;
  canvas.renderAll();
};

export const handleGradientPallete = (e, PalleteColor, canvas) => {
  var obj = canvas.getActiveObject();
  if (!obj) {
    return;
  }
  obj.set(
    "fill",
    new fabric.Gradient({
      //gradient options
      type: "linear",
      gradientUnits: "pixels", // or 'percentage'
      coords: { x1: 0, y1: 0, x2: obj.width, y2: obj.height },
      colorStops: [
        { offset: 0, color: Object.values(PalleteColor[e])[0] },
        { offset: 1, color: Object.values(PalleteColor[e])[1] },
      ],
    })
  );
  canvas.renderAll();
};
//Pencil Box
export const lineWidthChange = (e, setLinewidthValue, canvas) => {
  setLinewidthValue(e);
  canvas.freeDrawingBrush.width = parseInt(e, 10) || 1;
  canvas.renderAll();
};
export const shadowWidthChange = (e, setShadowWidthValue, canvas) => {
  setShadowWidthValue(e);
  if (!canvas.freeDrawingBrush.shadow) {
    canvas.freeDrawingBrush.shadow = new fabric.Shadow({
      blur: parseInt(e, 10) || 0,
      offsetX: 0,
      offsetY: 0,
      affectStroke: true,
      color: "#000000",
    });
  } else {
    canvas.freeDrawingBrush.shadow.blur = parseInt(e, 10) || 0;
  }
  canvas.renderAll();
};
export const shadowOffsetChange = (e, setShadowOffsetValue, canvas) => {
  setShadowOffsetValue(e);
  if (!canvas.freeDrawingBrush.shadow) {
    canvas.freeDrawingBrush.shadow = new fabric.Shadow({
      blur: parseInt(e, 10) || 0,
      offsetX: 0,
      offsetY: 0,
      affectStroke: true,
      color: "#000000",
    });
  } else {
    canvas.freeDrawingBrush.shadow.offsetX = parseInt(e, 10) || 0;
    canvas.freeDrawingBrush.shadow.offsetY = parseInt(e, 10) || 0;
  }
  canvas.renderAll();
};

export const handleLineColorChange = (e, canvas) => {
  canvas.freeDrawingBrush.color = e.hex;
  // if (brush.getPatternSrc) {
  //   brush.source = brush.getPatternSrc.call(brush);
  // }
  canvas.renderAll();
};
export const handleShadowColorChange = (e, canvas) => {
  if (!canvas.freeDrawingBrush.shadow) {
    canvas.freeDrawingBrush.shadow = new fabric.Shadow({
      blur: parseInt(e, 10) || 0,
      offsetX: 0,
      offsetY: 0,
      affectStroke: true,
      color: e,
    });
  } else {
    canvas.freeDrawingBrush.shadow.color = e.hex;
  }
  canvas.renderAll();
};

//set
export const handleModeChange = (e, setDefaultMode, canvas) => {
  setDefaultMode(e);

  switch (e) {
    case "pencil":
      canvas.isDrawingMode = true;
      canvas.freeDrawingBrush = new fabric.PencilBrush(canvas);
      break;
    case "circle":
      canvas.isDrawingMode = true;
      canvas.freeDrawingBrush = new fabric.CircleBrush(canvas);
      break;
    case "spray":
      canvas.isDrawingMode = true;
      canvas.freeDrawingBrush = new fabric.SprayBrush(canvas);
      break;
    // case "crayon":
    //   canvas.isDrawingMode = true;
    //   canvas.freeDrawingBrush = new fabric.InkBrush(canvas);
    //   break;
    default:
      canvas.isDrawingMode = false;
      break;
  }
};
var _clipboard;
export function Copy(canvas) {
  const obj = canvas.getActiveObject();
  if (obj) {
    obj.clone(function(cloned) {
      _clipboard = cloned;
    });
  }
}
export function Paste(canvas) {
  // clone again, so you can do multiple copies.
  if (_clipboard) {
    _clipboard.clone(function(clonedObj) {
      canvas.discardActiveObject();
      clonedObj.set({
        left: clonedObj.left + 10,
        top: clonedObj.top + 10,
        evented: true,
      });
      if (clonedObj.type === "activeSelection") {
        // active selection needs a reference to the canvas.
        clonedObj.canvas = canvas;
        clonedObj.forEachObject(function(obj) {
          canvas.add(obj);
        });
        // this should solve the unselectability
        clonedObj.setCoords();
      } else {
        canvas.add(clonedObj);
      }
      _clipboard.top += 10;
      _clipboard.left += 10;
      canvas.setActiveObject(clonedObj);
      canvas.requestRenderAll();
    });
  }
}
